import React, { useEffect, useMemo, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Modal } from 'reactstrap';
import '../Daylight.css';
import DaylightAddMappingModal from '../DaylightAddMappingModal/DaylightAddMappingModal';
import DaylightEditMappingModal from '../DaylightEditMappingModal/DaylightEditMappingModal';
import { actions } from '../../../../context';
import hasPermission from '../../../Shared/hasPermission';
import CodeMapperFooter from './CodeMapperFooter/';
import CodeMapperHeader from './CodeMapperHeader/CodeMapperHeader';
import CodeMapperBody from './CodeMapperBody/CodeMapperBody';
import DaylightMappingCommentModal from '../DaylightMappingCommentModal/DaylightMappingCommentModal';
const defaultPermissions = {
    canFlagForReview: false,
    canReview: false,
    canManageDaylightSync: false,
};
const defaultValue = {
    practiceId: '',
    practiceName: '',
    codeUsageStatsMap: new Map([]),
    ...defaultPermissions,
};
export const DaylightContext = React.createContext(defaultValue);

// TODO: needs a lot more love, pagination ticket etc.
const DaylightCodeMapper = () => {
    const dispatch = useDispatch();

    const [codeUsageStats, setCodeUsageStats] = useState([]);

    const isDaylightCodeModalVisible = useSelector(
        (state) => state.daylight.daylightCodeModalVisible
    );
    const practiceId = useSelector((state) => state.daylight.practice?.id);
    const practiceName = useSelector((state) => state.daylight.practice.name);
    const partnerId = useSelector((state) => state.daylight.partnerIdFilter);
    const addMappingOpen = useSelector(
        (state) => state.daylight.isAddMappingModalOpen
    );
    const editMappingOpen = useSelector(
        (state) => state.daylight.isEditMappingModalOpen
    );

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canFlagForReview = hasPermission(
        'DaylightFlagForReview',
        permissions
    );
    const canReview = hasPermission('DaylightReview', permissions);
    const canManageDaylightSync = hasPermission(
        'ManageDaylightSync',
        permissions
    );

    useEffect(() => {
        dispatch(
            actions.daylight.fetchDaylightUserHasAccessToUsageDetails(
                practiceId
            )
        ).then((hasAccessRes) => {
            if (hasAccessRes) {
                dispatch(
                    actions.daylight.fetchDaylightCodeUsageDetails(practiceId)
                ).then((detailsRes) => setCodeUsageStats(detailsRes));
            }
        });
    }, [dispatch, practiceId]);

    const codeUsageStatsMap = new Map(
        codeUsageStats.map((stat) => [stat.codeId, stat])
    );

    const globalValues = useMemo(
        () => ({
            practiceId,
            practiceName,
            partnerId,
            canFlagForReview,
            canReview,
            canManageDaylightSync,
            codeUsageStatsMap,
        }),
        [
            practiceId,
            practiceName,
            partnerId,
            canFlagForReview,
            canReview,
            canManageDaylightSync,
            codeUsageStatsMap,
        ]
    );

    const closeBehavior = () => {
        dispatch(actions.daylight.setSelectedPartnerId(null));
    };

    return (
        <DaylightContext.Provider value={globalValues}>
            <Modal
                isOpen={isDaylightCodeModalVisible}
                onClosed={() => closeBehavior()}
                className="text-light"
                centered
                // style={{ minWidth: '95vw' }}>
                style={{ minWidth: '97vw' }}>
                {addMappingOpen && (
                    <DaylightAddMappingModal practiceId={practiceId} />
                )}

                {editMappingOpen && (
                    <DaylightEditMappingModal practiceId={practiceId} />
                )}

                <DaylightMappingCommentModal />

                <CodeMapperHeader practiceName={practiceName} />

                {/* has the code list tree */}
                <CodeMapperBody />

                {/* has button to toggle "complete" status */}
                {/* has button to download code export */}
                {/* has button to close the modal */}
                <CodeMapperFooter />
            </Modal>
        </DaylightContext.Provider>
    );
};

export default DaylightCodeMapper;
